<template>
  <div class="container">
    <div class="title" v-if="!editId">
      新建项目模块{{ editId }}
      <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>
    <div class="title" v-else>
      <span>修改模块</span> <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>

    <div class="wrap">
      <el-row>
        <el-col :lg="16" :md="20" :sm="24" :xs="24">
          <el-form :model="projectModule" status-icon ref="form" label-width="auto" @submit.prevent :rules="rules">
            <!-- <el-form-item label="所属项目" prop="project_id">
              <el-select
                v-model="projectModule.project_id"
                placeholder="所属项目"
                style="width: 150px"
                clearable
                filterable
              >
                <el-option v-for="item in projectInfoArr" :key="item.id" :label="item.project_name" :value="item.id" />
              </el-select>
            </el-form-item> -->

            <el-form-item label="父模块">
              <dynamic-tree-table
                :treeList="tree.treeList"
                :idField="tree.id"
                :nameField="tree.name"
                :multiple="tree.multiple"
                @update:selectedValue="handleSelectedValue"
                :selectedNodes="projectModule.parent_id"
              ></dynamic-tree-table>
            </el-form-item>

            <el-form-item label="模块名称" prop="module_name">
              <el-input v-model="projectModule.module_name" placeholder="请输入模块名称" clearable />
            </el-form-item>

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm">保 存</el-button>
              <el-button @click="resetForm">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import DynamicTreeTable from '@/component/tree/dynamicTreeTable'
import ProjectInfo from '@/model/projectInfo'
import ProjectModuleInfo from '@/model/projectModuleInfo'
import sysDictItemModel from '@/model/sysDictItem'
import ProjectDaily from '@/model/projectDaily'
import CompanyInfo from '@/model/companyInfo'
import ContactInfo from '@/model/contactInfo'

export default {
  components: {
    DynamicTreeTable,
  },
  props: {
    editId: {
      type: String,
      default: null,
    },
    parentId: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    const form = ref(null)
    const loading = ref(false)

    const projectInfoArr = ref([])
    const projectModuleArr = ref([])

    const projectModule = reactive({
      id: '',
      project_id: '',
      parent_id: '',
      module_name: '',
    })

    if (props.parentId) {
      projectModule.parent_id = props.parentId
    }

    const tree = ref({
      id: 'id',
      name: 'name',
      treeList: [],
      dialogVisible: true,
      value: [],
      treeKey: 0,
      multiple: false,
    })

    const treeData = ref([])

    const listAssign = (a, b) => Object.keys(a).forEach(key => {
      a[key] = b[key] || a[key]
    })

    /**
     * 表单规则验证
     */
    const { rules } = getRules()

    onMounted(() => {
      loadDictDitems()
    })

    // 根据字典类型查询字典
    const loadDictDitems = async () => {
      projectInfoArr.value = await ProjectInfo.getProjectInfoList({})
      projectModuleArr.value = await ProjectInfo.getProjectInfoList({})

      // 加载树
      await getProjectModuleTree()

      if (props.editId) {
        await getProjectInfo()
      }
    }

    const getProjectModuleTree = async () => {
      const res = await ProjectModuleInfo.getProjectModuleTree({ module_name: '' })
      tree.value.treeList = res
    }

    const getProjectInfo = async () => {
      loading.value = true
      const res = await ProjectModuleInfo.getProjectModuleInfo(props.editId)
      listAssign(projectModule, res)
      projectModule.parent_id = res.parent_id
      console.log('aaaaaa')
      console.log(res)
      loading.value = false
    }

    // 重置表单
    const resetForm = () => {
      form.value.resetFields()
      Object.keys(projectModule).forEach(key => {
        projectModule[key] = '' // 清空属性值
      })
    }

    const submitForm = async formName => {
      form.value.validate(async valid => {
        if (valid) {
          let res = {}
          if (props.editId) {
            res = await ProjectModuleInfo.editProjectModuleInfo(props.editId, projectModule)
            context.emit('editClose')
          } else {
            console.log('projectModule')
            console.log(projectModule)
            // return ;
            res = await ProjectModuleInfo.createProjectModuleInfo(projectModule)
            resetForm(formName)
          }
          if (res.code < window.MAX_SUCCESS_CODE) {
            ElMessage.success(`${res.message}`)
          }
          getProjectModuleTree()
        } else {
          console.error('error submit!!')
          ElMessage.error('请将信息填写完整')
        }
      })
    }

    const back = () => {
      context.emit('editClose')
    }

    const handleSelectedValue = value => {
      projectModule.parent_id = value
      console.log(`获取到的值是：${value}`)
    }

    return {
      back,
      projectModule,
      form,
      rules,
      resetForm,
      submitForm,

      projectInfoArr,
      projectModuleArr,

      tree,
      treeData,
      handleSelectedValue,
    }
  },
}

/**
 * 表单验证规则
 */
function getRules() {
  /**
   * 验证回调函数
   */
  const checkInfo = (rule, value, callback) => {
    if (!value) {
      callback(new Error('信息不能为空'))
    }
    callback()
  }
  const rules = {
    // project_id: [{ validator: checkInfo, trigger: 'blur', required: true }],
    module_name: [{ validator: checkInfo, trigger: 'blur', required: true }],
    parent_id: [{ validator: checkInfo, trigger: 'blur', required: true }],
  }
  return { rules }
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
